import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const TEMPLATES_URL = `${domain}/api/templates`;

export const templatesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllTemplateDates: builder.query({
      query: () => ({
        url: `${TEMPLATES_URL}/templatedates`,
      }),
      providesTags: ["TemplateDates"],
    }),
    getTemplateDowIds: builder.query({
      query: (templateId) => ({
        url: `${TEMPLATES_URL}/templatedowids/${templateId}`,
      }),
      providesTags: ["TemplateDates"],
    }),
    getTemplatePrograms: builder.query({
      query: (programs) => ({
        url: `${TEMPLATES_URL}/templateprograms/${programs}`,
      }),
      providesTags: ["TemplatePrograms"],
    }),
    getTemplateProgram: builder.query({
      query: (programs) => ({
        url: `${TEMPLATES_URL}/templateprogram/${programs}`,
      }),
      providesTags: ["TemplatePrograms"],
    }),
    addTemplateProgram: builder.mutation({
      query: (programData) => ({
        url: `${TEMPLATES_URL}/inserttemplateprogram`,
        method: "POST",
        body: programData,
      }),
      invalidatesTags: ["TemplatePrograms"],
    }),
    updateTemplateProgram: builder.mutation({
      query: (programData) => ({
        url: `${TEMPLATES_URL}/updatetemplateprogram/${programData._id}`,
        method: "PUT",
        body: programData,
      }),
      invalidatesTags: ["TemplatePrograms"],
    }),
    deleteTemplateProgram: builder.mutation({
      query: (id) => ({
        url: `${TEMPLATES_URL}/deleteprogram/${id}`,
        method: "DELETE",
        body: id,
      }),
      invalidatesTags: ["TemplatePrograms"],
    }),
    updateTemplatePrograms: builder.mutation({
      query: () => ({
        url: `${TEMPLATES_URL}/templateupdateprocess`,
        method: "POST",
      }),
      invalidatesTags: ["TemplatePrograms"],
    }),
  }),
});

export const {
  useGetAllTemplateDatesQuery,
  useGetTemplateDowIdsQuery,
  useGetTemplateProgramsQuery,
  useDeleteTemplateProgramMutation,
  useAddTemplateProgramMutation,
  useUpdateTemplateProgramMutation,
  useUpdateTemplateProgramsMutation,
  useGetTemplateProgramQuery,
} = templatesApiSlice;
